export function initializeKeyfiguresFilters(translate) {
  let initialFilters = [
    {
      id: "nogaCode",
      label: translate("benchmarking.evaluations.overheads.filters.noga"),
      items: [],
    },
    {
      id: "surveyYears",
      label: translate("benchmarking.evaluations.overheads.filters.year"),
      items: [],
    },
    {
      id: "officeSize",
      label: translate("benchmarking.evaluations.overheads.filters.officeSize"),
      items: [],
      ignoreSort: true,
    },
    {
      id: "greaterRegion",
      label: translate("benchmarking.evaluations.overheads.filters.canton"),
      items: [],
    },
  ];
  return { filters: initialFilters, newest: true, isInitialLoad: true, allAvailabeFilters: {} };
}
